import { __decorate, __extends } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { NeoReactTypes } from '../Modules/Types';
import { Misc } from '@singularsystems/neo-core';
var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            visible: false,
            selectedColor: _this.props.bind.value
        };
        _this.sketchPickerImplementation = Misc.Globals.appService.get(NeoReactTypes.Components.SketchPicker);
        _this.handleChange = function (color) {
            // Set the color value
            _this.setState({ selectedColor: color.hex });
        };
        _this.visibleToggle = function () {
            _this.setState({ visible: !_this.state.visible });
        };
        _this.cancel = function () {
            // Reset the color
            _this.setState({ selectedColor: _this.props.bind.value });
            _this.visibleToggle();
        };
        _this.accept = function () {
            _this.props.bind.value = _this.state.selectedColor;
            _this.visibleToggle();
            // Check if there is a custom event
            if (_this.props.onChangeEvent) {
                _this.props.onChangeEvent();
            }
        };
        return _this;
    }
    ColorPicker.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.bind.value !== this.state.selectedColor) {
            // Update the state selectedColor if the color that was in the bind was changed
            this.setState({ selectedColor: nextProps.bind.value });
        }
    };
    ColorPicker.prototype.componentDidMount = function () {
        this.setState({ selectedColor: this.props.bind.value });
    };
    ColorPicker.prototype.render = function () {
        var _this = this;
        var style = { backgroundColor: this.props.bind.value };
        return (React.createElement("div", { className: "color-picker" },
            React.createElement("div", { className: "mode-overlay" },
                React.createElement("div", { className: 'block-button', style: style, onClick: function () { return _this.visibleToggle(); } }),
                this.state.visible &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: "overlay-area", onClick: function () { return _this.cancel(); } }),
                        React.createElement("div", { className: "picker-container" },
                            React.createElement("div", { className: "picker-block" },
                                React.createElement(this.sketchPickerImplementation, { color: this.state.selectedColor, onChange: this.handleChange }),
                                React.createElement("div", { className: "action-container" },
                                    React.createElement("div", { className: "btn btn-primary btn-sm", onClick: function () { return _this.accept(); } }, "Accept"),
                                    React.createElement("div", { className: "btn btn-secondary btn-sm ml-1 mr-1", onClick: function () { return _this.cancel(); } }, "Cancel"))))))));
    };
    ColorPicker = __decorate([
        observer
    ], ColorPicker);
    return ColorPicker;
}(React.Component));
export default ColorPicker;
